// extracted by mini-css-extract-plugin
module.exports = {"glacierWaveTreaserH5":"treaser_glacierWaveTreaserH5__LhTs8"};